import { Box, Button, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

/**
 * Shared component for file attachment section
 * Used in CreateCommitmentsForm.jsx to reduce duplication
 */
export const AttachFilesSection = ({ showLabel = false, label = "Attachments" }) => (
  <Grid container mb={2}>
    <Grid item xs={12}>
      {showLabel && (
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          {label}
        </Typography>
      )}
      <Box
        sx={{
          border: "1px dashed #ccc",
          p: 2,
          textAlign: "center",
          borderRadius: 1,
          height: 76,
          width: 1215,
        }}
      >
        <Typography variant="body2" color="textSecondary">
          Attach Files or Drag & Drop
        </Typography>
        <Button variant="contained" sx={{ mt: 1 }}>
          Attach Files
        </Button>
      </Box>
    </Grid>
  </Grid>
);

AttachFilesSection.propTypes = {
  showLabel: PropTypes.bool,
  label: PropTypes.string,
};
